import jwtDecode from "jwt-decode";

export function getCurrentPermissions() {
  let permissions = JSON.parse(localStorage.getItem("permissions")) || [];
  const token = localStorage.getItem("token");

  if (token) {
    try {
      const payload = jwtDecode(token);
      if (payload?.IsAdmin && permissions.indexOf("e_voucher") < 0) {
        permissions = [...permissions, "e_voucher"];
        localStorage.setItem("permissions", JSON.stringify(permissions));
      }
    } catch (_) {
      return permissions;
    }
  }

  return permissions;
}
